import { ProductService } from '../../../frameworks_drivers/redux/reducers/onboardingInformation';
import { useConfirmOfferState } from './ConfirmOfferStateProvider';

const sumPrice = (products: Array<any>) => {
  if (products.length === 0) {
    return 0;
  }

  return products
    .map((item: ProductService) => +item.price)
    .reduce((sum: number, current: number) => sum + current);
};

const useConfirmOfferController = () => {
  const state = useConfirmOfferState();
  return { state: state, actions: { sumPrice } };
};

export default useConfirmOfferController;
